import styled from 'styled-components';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';
import { Form } from 'formik';

export const SignUpButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    min-width: 100px;
  }
`;

export const SignUpForm = styled(Form)`

    display: flex;
    flex-direction: column;
    gap: 1rem;

`;
